import { isUndNullEmp } from '../../../helpers/main';

export class SwalPropertiesClass {
    constructor(
        icon = '',
        title = '',
        html = '',
        timer = null,
        backdrop = false,
        confirmButtonColor = '',
        confirmButtonText = '',
        showCancelButton = false,
        cancelButtonColor = '',
        cancelButtonText = '',
        showLoaderOnConfirm = false,
        didOpen = () => { },
        allowOutsideClick = () => false,
        preConfirm = async () => { },
    ) {
        this.icon = icon;
        this.title = title;
        this.html = html;
        this.timer = timer;
        this.backdrop = backdrop;
        this.confirmButtonColor = confirmButtonColor;
        this.confirmButtonText = confirmButtonText;
        this.showCancelButton = showCancelButton;
        this.cancelButtonColor = cancelButtonColor;
        this.cancelButtonText = cancelButtonText;
        this.showLoaderOnConfirm = showLoaderOnConfirm;
        this.didOpen = didOpen;
        this.allowOutsideClick = allowOutsideClick;
        this.preConfirm = preConfirm;
    }

    getClassName = () => {
        return 'Swal properties - class';
    }

    getClass = (obj = {}) => {
        if (!isUndNullEmp({ data: obj, subMethod: this?.getClassName() })?.result) {
            return new SwalPropertiesClass(
                obj?.icon,
                obj?.title,
                obj?.html,
                obj?.timer,
                obj?.backdrop,
                obj?.confirmButtonColor,
                obj?.confirmButtonText,
                obj?.showCancelButton,
                obj?.cancelButtonColor,
                obj?.cancelButtonText,
                obj?.showLoaderOnConfirm,
                obj?.didOpen,
                obj?.allowOutsideClick,
                obj?.preConfirm,
            );
        }

        return new SwalPropertiesClass();
    }
}